<template>
  <component :is="way" v-bind="{ ...$props, ...$attrs }" v-on="$listeners" />
</template>

<script>
import { mapGetters } from 'vuex';
import PROCESS_NAMES from '@/process/names';
import ActionsDefault from './ActionsDefault';
const ActionsSportmaster = () => import(/* webpackChunkName: "invites-actions-sportmaster" */'@/process/sportmaster/components/invites/ActionsSportmaster');

export default {
  name: 'additional-actions',

  props: {
    response: Object
  },

  components: {
    ActionsDefault,
    ActionsSportmaster
  },

  computed: {
    ...mapGetters('process', ['getProcessName']),

    way() {
      if (this.getProcessName !== undefined) {
        if (this.getProcessName === PROCESS_NAMES.SPORTMASTER) {
          return `actions-${this.getProcessName}`;
        }
      }

      return `actions-default`;
    }
  }
}
</script>
